(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-gallery"] && !Shopify.designMode) return;
  try {
    
function initFKGallery(root) {
  root.querySelectorAll('[data-fk-gallery]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.fk-gallery'), cards = [...track.children];
    if (!cards.length) return;
    const prev = section.querySelector('[data-fk-prev]'), next = section.querySelector('[data-fk-next]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const cardStep = () => cards[0].offsetWidth + parseFloat(getComputedStyle(track).gap || 0);
    const step = direction => track.scrollBy({ left: direction * cardStep(), behavior: reduced ? 'instant' : 'smooth' });
    prev.addEventListener('click', () => step(-1)); next.addEventListener('click', () => step(1));
    track.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1); } });
    const update = () => {
      const index = Math.min(cards.length, Math.round(track.scrollLeft / cardStep()) + 1);
      section.querySelector('.fk-progress').textContent = String(index).padStart(2,'0') + ' / ' + String(cards.length).padStart(2,'0');
      prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    track.addEventListener('scroll', update, {passive:true}); window.addEventListener('resize', update); update();
  });
}
initFKGallery(document);
document.addEventListener('shopify:section:load', event => initFKGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-header"]) return;
  try {
    
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.fk-mobile-menu[open]').forEach(menu => menu.removeAttribute('open')); });
document.addEventListener('click', event => { document.querySelectorAll('.fk-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.removeAttribute('open'); }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-runway"] && !Shopify.designMode) return;
  try {
    
function initFKRunway(root) {
  root.querySelectorAll('[data-fk-runway]').forEach(section => {
    if(section.dataset.ready) return;
    section.dataset.ready='true';
    const links=[...section.querySelectorAll('[data-fk-look]')], dialog=section.querySelector('dialog');
    if(!dialog || !dialog.showModal || !links.length) return;
    let index=0;
    const show = next => {
      index=(next+links.length)%links.length;
      const thumbnail=links[index].querySelector('img'), image=new Image();
      image.src=thumbnail.currentSrc || thumbnail.src; image.alt=thumbnail.alt || '';
      const full=new Image(); full.onload=()=>{if(dialog.querySelector('.fk-lightbox-stage').firstChild===image)image.src=full.src;}; full.src=links[index].href;
      dialog.querySelector('.fk-lightbox-stage').replaceChildren(image);
      dialog.querySelector('.fk-lightbox-caption').textContent=(index+1)+' / '+links.length+' — '+(Array.from(links[index].closest('figure').querySelector('figcaption')?.childNodes || []).map(node=>node.textContent.trim()).filter(Boolean).join(' — '));
    };
    links.forEach((link,i)=>link.addEventListener('click',event=>{event.preventDefault();show(i);dialog.showModal();}));
    dialog.querySelector('[data-fk-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-fk-prev-look]').addEventListener('click',()=>show(index-1));
    dialog.querySelector('[data-fk-next-look]').addEventListener('click',()=>show(index+1));
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  });
}
initFKRunway(document);
document.addEventListener('shopify:section:load',event=>initFKRunway(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
